module.exports = __webpack_public_path__ + "img/guigui_cat.91945e7c.png";